import React from 'react';
import classNames from 'classnames';

import { biLogger } from '../../../../client/bi';

import { IWithI18nProps, withI18n } from '../../../../components/context/i18n';
import {
  IWithSettingsProps,
  withSettings,
} from '../../../../components/context/settings';

import { EpisodeLink } from '../../../../components/nav';

import { IPodcastEpisode } from '@wix/podcasts-common/dist/podcast';

import getStyles from './Nav.styles';
import styles from './Nav.scss';

interface IEpisodePageNavPrevNextProps
  extends IWithI18nProps,
    IWithSettingsProps {
  episode: Pick<IPodcastEpisode, 'id'>;
  prevEpisode: Pick<IPodcastEpisode, 'id' | 'slug'>;
  nextEpisode: Pick<IPodcastEpisode, 'id' | 'slug'>;
}

function EpisodePageNavPrevNext({
  episode,
  prevEpisode,
  nextEpisode,
  t,
  settings,
}: IEpisodePageNavPrevNextProps) {
  const dynamicStyles = getStyles({
    colors: settings.colors.episode,
    fonts: settings.fonts.episode,
  });

  return (
    <div className={styles.prevNextWrapper}>
      <div className={styles.prevNextContainer}>
        <div className={styles.prevContainer}>
          {prevEpisode && (
            <EpisodeLink
              id={prevEpisode.id}
              slug={prevEpisode.slug}
              onClick={() => {
                biLogger.episodeNavigationClick({
                  button: 'previous',
                  episodeId: episode.id,
                  requestedEpisodeId: prevEpisode.id,
                });
              }}
            >
              <a
                className={classNames(styles.prev, dynamicStyles.prevNext)}
                data-hook="episode.nav.link-prev-episode"
              >
                &larr;
                <span className={styles.navShortText}>
                  {t('pages.episode.link-prev')}
                </span>
                <span className={styles.navLongText}>
                  {t('pages.episode.link-prev-episode')}
                </span>
              </a>
            </EpisodeLink>
          )}
          <div className={styles.prevNextSpace} />
        </div>
        <div className={styles.nextContainer}>
          <div className={styles.prevNextSpace} />
          {nextEpisode && (
            <EpisodeLink
              id={nextEpisode.id}
              slug={nextEpisode.slug}
              onClick={() => {
                biLogger.episodeNavigationClick({
                  button: 'next',
                  episodeId: episode.id,
                  requestedEpisodeId: nextEpisode.id,
                });
              }}
            >
              <a
                className={classNames(styles.next, dynamicStyles.prevNext)}
                data-hook="episode.nav.link-next-episode"
              >
                <span className={styles.navShortText}>
                  {t('pages.episode.link-next')}
                </span>
                <span className={styles.navLongText}>
                  {t('pages.episode.link-next-episode')}
                </span>
                &rarr;
              </a>
            </EpisodeLink>
          )}
        </div>
      </div>
    </div>
  );
}

export default withSettings(withI18n(EpisodePageNavPrevNext));
